<script>
  let { assetsPath = '/', onAiMounted = () => {} } = $props();
  import { onMount } from 'svelte';
  onMount(() => {
    onAiMounted();
  });
</script>

<div id="g-tehran-map-box">
  <!-- Artboard: xs -->
  <div
    id="g-tehran-map-xs"
    class="g-artboard"
    style="display: none;aspect-ratio: 0.86842105263158;"
  >
    <div
      id="g-tehran-map-xs-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/tehran-map-xs.jpg);"
    ></div>
    <div
      id="g-ai0-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:9.4732%;margin-top:-2px;left:82.8442%;width:57px;"
    >
      <p class="g-pstyle0">Tehran</p>
    </div>
    <div
      id="g-ai0-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:14.6266%;margin-top:-2.6px;left:85.6549%;margin-left:-31.5px;width:63px;"
    >
      <p class="g-pstyle1">IRAN</p>
    </div>
    <div
      id="g-ai0-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:47.1047%;margin-top:-5px;left:41.0421%;margin-left:-34.5px;width:69px;"
    >
      <p class="g-pstyle2">Tehran</p>
    </div>
    <div
      id="g-ai0-4"
      class="g-text g-aiAbs g-aiPointText"
      style="top:58.6619%;margin-top:-13.9px;right:54.5307%;width:76px;"
    >
      <p class="g-pstyle3">Mehrabad</p>
      <p class="g-pstyle3">International</p>
      <p class="g-pstyle3">Airport</p>
    </div>
    <div
      id="g-ai0-5"
      class="g-text g-aiAbs g-aiPointText"
      style="top:59.8461%;margin-top:-9.4px;left:64.1958%;margin-left:-39.5px;width:79px;"
    >
      <p class="g-pstyle4">Tehran</p>
      <p class="g-pstyle4">Grand Bazaar</p>
    </div>
    <div
      id="g-ai0-6"
      class="g-text g-aiAbs g-aiPointText"
      style="top:76.4469%;margin-top:-7.5px;right:61.5894%;width:98px;"
    >
      <p class="g-pstyle5">Israeli airstrike</p>
    </div>
    <div
      id="g-ai0-7"
      class="g-text g-aiAbs g-aiPointText"
      style="top:94.8679%;margin-top:-7.5px;left:8.1166%;margin-left:-23.5px;width:47px;"
    >
      <p class="g-pstyle6">5 km</p>
    </div>
  </div>

  <!-- Artboard: sm -->
  <div
    id="g-tehran-map-sm"
    class="g-artboard"
    style="display: none;aspect-ratio: 0.86440677966102;"
  >
    <div
      id="g-tehran-map-sm-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/tehran-map-sm.jpg);"
    ></div>
    <div
      id="g-ai1-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:9.4912%;margin-top:-3px;left:82.8184%;width:57px;"
    >
      <p class="g-pstyle0">Tehran</p>
    </div>
    <div
      id="g-ai1-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:13.8273%;margin-top:-3.6px;left:85.6363%;margin-left:-31.5px;width:63px;"
    >
      <p class="g-pstyle1">IRAN</p>
    </div>
    <div
      id="g-ai1-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:46.5532%;margin-top:-7.7px;left:41.1657%;margin-left:-42.5px;width:85px;"
    >
      <p class="g-pstyle2">Tehran</p>
    </div>
    <div
      id="g-ai1-4"
      class="g-text g-aiAbs g-aiPointText"
      style="top:57.7115%;margin-top:-18.5px;right:55.0084%;width:87px;"
    >
      <p class="g-pstyle3">Mehrabad</p>
      <p class="g-pstyle3">International</p>
      <p class="g-pstyle3">Airport</p>
    </div>
    <div
      id="g-ai1-5"
      class="g-text g-aiAbs g-aiPointText"
      style="top:59.5759%;margin-top:-12.5px;left:64.384%;margin-left:-45.5px;width:91px;"
    >
      <p class="g-pstyle4">Tehran</p>
      <p class="g-pstyle4">Grand Bazaar</p>
    </div>
    <div
      id="g-ai1-6"
      class="g-text g-aiAbs g-aiPointText"
      style="top:75.9459%;margin-top:-9.1px;right:61.4486%;width:111px;"
    >
      <p class="g-pstyle5">Israeli airstrike</p>
    </div>
    <div
      id="g-ai1-7"
      class="g-text g-aiAbs g-aiPointText"
      style="top:94.4205%;margin-top:-9.1px;left:8.966%;margin-left:-26px;width:52px;"
    >
      <p class="g-pstyle6">5 km</p>
    </div>
  </div>

  <!-- Artboard: md -->
  <div
    id="g-tehran-map-md"
    class="g-artboard"
    style="display: none;aspect-ratio: 1.11864406779661;"
  >
    <div
      id="g-tehran-map-md-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/tehran-map-md.jpg);"
    ></div>
    <div
      id="g-ai2-1"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:9.4912%;margin-top:-3px;left:86.7233%;width:57px;"
    >
      <p class="g-pstyle0">Tehran</p>
    </div>
    <div
      id="g-ai2-2"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:13.8273%;margin-top:-3.6px;left:88.9008%;margin-left:-31.5px;width:63px;"
    >
      <p class="g-pstyle1">IRAN</p>
    </div>
    <div
      id="g-ai2-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:46.5532%;margin-top:-7.7px;left:49.9922%;margin-left:-42.5px;width:85px;"
    >
      <p class="g-pstyle2">Tehran</p>
    </div>
    <div
      id="g-ai2-4"
      class="g-text g-aiAbs g-aiPointText"
      style="top:57.7115%;margin-top:-18.5px;right:47.0517%;width:87px;"
    >
      <p class="g-pstyle3">Mehrabad</p>
      <p class="g-pstyle3">International</p>
      <p class="g-pstyle3">Airport</p>
    </div>
    <div
      id="g-ai2-5"
      class="g-text g-aiAbs g-aiPointText"
      style="top:59.5759%;margin-top:-12.5px;left:67.9335%;margin-left:-45.5px;width:91px;"
    >
      <p class="g-pstyle4">Tehran</p>
      <p class="g-pstyle4">Grand Bazaar</p>
    </div>
    <div
      id="g-ai2-6"
      class="g-text g-aiAbs g-aiPointText"
      style="top:75.9459%;margin-top:-9.1px;right:52.028%;width:111px;"
    >
      <p class="g-pstyle5">Israeli airstrike</p>
    </div>
    <div
      id="g-ai2-7"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:94.4205%;margin-top:-9.1px;left:7.1555%;margin-left:-26px;width:52px;"
    >
      <p class="g-pstyle6">5 km</p>
    </div>
  </div>

  <!-- Artboard: lg -->
  <div
    id="g-tehran-map-lg"
    class="g-artboard"
    style="display: none;aspect-ratio: 1.5;"
  >
    <div
      id="g-tehran-map-lg-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/tehran-map-lg.jpg);"
    ></div>
    <div
      id="g-ai3-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:45.1071%;margin-top:-9.7px;left:40.3873%;width:201px;"
    >
      <p class="g-pstyle0">Primary annotation @16px</p>
    </div>
    <div
      id="g-ai3-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:50.0937%;margin-top:-9.6px;left:40.3873%;width:194px;"
    >
      <p class="g-pstyle1">Secondary annotation @14px</p>
    </div>
    <div
      id="g-ai3-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:55.2416%;margin-top:-9.5px;left:40.3873%;width:154px;"
    >
      <p class="g-pstyle2">Tertiary annotation @12px</p>
    </div>
  </div>
</div>

<!-- End ai2html - 2025-06-17 12:32 -->

<!-- Generated by ai2html v0.101.0 - 2025-06-17 12:32 -->
<!-- ai file: tehran-map.ai -->
<style lang="scss">
  #g-tehran-map-box,
  #g-tehran-map-box .g-artboard {
    margin: 0 auto;
  }
  #g-tehran-map-box p {
    margin: 0;
  }
  #g-tehran-map-box .g-aiAbs {
    position: absolute;
  }
  #g-tehran-map-box .g-aiImg {
    position: absolute;
    top: 0;
    display: block;
    width: 100% !important;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
  }
  #g-tehran-map-box .g-aiPointText p {
    white-space: nowrap;
  }
  #g-tehran-map-box {
    container-type: inline-size;
    @container (min-width:0px) and (max-width: 509px) {
      #g-tehran-map-xs {
        display: block !important;
      }
    }
    @container (min-width:510px) and (max-width: 659px) {
      #g-tehran-map-sm {
        display: block !important;
      }
    }
    @container (min-width:660px) and (max-width: 929px) {
      #g-tehran-map-md {
        display: block !important;
      }
    }
    @container (min-width:930px) {
      #g-tehran-map-lg {
        display: block !important;
      }
    }
  }
  #g-tehran-map-xs {
    position: relative;
    overflow: hidden;
  }
  #g-tehran-map-xs p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 400;
    line-height: 9px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 10px;
    text-align: left;
    color: rgb(0, 0, 0);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-tehran-map-xs .g-pstyle0 {
    font-weight: 500;
    line-height: 3px;
    height: 3px;
    font-size: 12px;
    color: rgb(64, 64, 64);
  }
  #g-tehran-map-xs .g-pstyle1 {
    font-weight: 700;
    line-height: 4px;
    height: 4px;
    letter-spacing: 0.2em;
    font-size: 14px;
    text-align: center;
    text-transform: uppercase;
  }
  #g-tehran-map-xs .g-pstyle2 {
    font-weight: 500;
    height: 9px;
    letter-spacing: 0.2em;
    font-size: 12px;
    text-align: center;
  }
  #g-tehran-map-xs .g-pstyle3 {
    height: 9px;
    text-align: right;
  }
  #g-tehran-map-xs .g-pstyle4 {
    height: 9px;
    text-align: center;
  }
  #g-tehran-map-xs .g-pstyle5 {
    font-weight: 500;
    line-height: 14px;
    height: 14px;
    font-size: 12px;
    text-align: right;
    color: rgb(165, 15, 21);
  }
  #g-tehran-map-xs .g-pstyle6 {
    font-weight: 500;
    line-height: 14px;
    height: 14px;
    font-size: 12px;
    text-align: center;
    color: rgb(64, 64, 64);
  }
  #g-tehran-map-sm {
    position: relative;
    overflow: hidden;
  }
  #g-tehran-map-sm p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 400;
    line-height: 12px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 12px;
    text-align: left;
    color: rgb(0, 0, 0);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-tehran-map-sm .g-pstyle0 {
    font-weight: 500;
    line-height: 5px;
    height: 5px;
    color: rgb(64, 64, 64);
  }
  #g-tehran-map-sm .g-pstyle1 {
    font-weight: 700;
    line-height: 6px;
    height: 6px;
    letter-spacing: 0.2em;
    font-size: 14px;
    text-align: center;
    text-transform: uppercase;
  }
  #g-tehran-map-sm .g-pstyle2 {
    font-weight: 500;
    line-height: 14px;
    height: 14px;
    letter-spacing: 0.2em;
    font-size: 16px;
    text-align: center;
  }
  #g-tehran-map-sm .g-pstyle3 {
    height: 12px;
    text-align: right;
  }
  #g-tehran-map-sm .g-pstyle4 {
    height: 12px;
    text-align: center;
  }
  #g-tehran-map-sm .g-pstyle5 {
    font-weight: 500;
    line-height: 17px;
    height: 17px;
    font-size: 14px;
    text-align: right;
    color: rgb(165, 15, 21);
  }
  #g-tehran-map-sm .g-pstyle6 {
    font-weight: 500;
    line-height: 17px;
    height: 17px;
    font-size: 14px;
    text-align: center;
    color: rgb(64, 64, 64);
  }
  #g-tehran-map-md {
    position: relative;
    overflow: hidden;
  }
  #g-tehran-map-md p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 400;
    line-height: 12px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 12px;
    text-align: left;
    color: rgb(0, 0, 0);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-tehran-map-md .g-pstyle0 {
    font-weight: 500;
    line-height: 5px;
    height: 5px;
    color: rgb(64, 64, 64);
  }
  #g-tehran-map-md .g-pstyle1 {
    font-weight: 700;
    line-height: 6px;
    height: 6px;
    letter-spacing: 0.2em;
    font-size: 14px;
    text-align: center;
    text-transform: uppercase;
  }
  #g-tehran-map-md .g-pstyle2 {
    font-weight: 500;
    line-height: 14px;
    height: 14px;
    letter-spacing: 0.2em;
    font-size: 16px;
    text-align: center;
  }
  #g-tehran-map-md .g-pstyle3 {
    height: 12px;
    text-align: right;
  }
  #g-tehran-map-md .g-pstyle4 {
    height: 12px;
    text-align: center;
  }
  #g-tehran-map-md .g-pstyle5 {
    font-weight: 500;
    line-height: 17px;
    height: 17px;
    font-size: 14px;
    text-align: right;
    color: rgb(165, 15, 21);
  }
  #g-tehran-map-md .g-pstyle6 {
    font-weight: 500;
    line-height: 17px;
    height: 17px;
    font-size: 14px;
    text-align: center;
    color: rgb(64, 64, 64);
  }
  #g-tehran-map-lg {
    position: relative;
    overflow: hidden;
  }
  #g-tehran-map-lg p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 400;
    line-height: 18px;
    height: auto;
    opacity: 1;
    padding-bottom: 0;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-tehran-map-lg .g-pstyle0 {
    height: 18px;
    padding-bottom: 9px;
    font-size: 16px;
  }
  #g-tehran-map-lg .g-pstyle1 {
    height: 18px;
    padding-bottom: 9px;
  }
  #g-tehran-map-lg .g-pstyle2 {
    height: 18px;
    padding-bottom: 9px;
    font-size: 12px;
    color: rgb(102, 102, 102);
  }

  /* Custom CSS */
  .g-text {
  }
</style>
